import * as React from "react";
import { Route, Switch } from "wouter";
import { EventPlanningList } from "./list/view";
import { PlanningEdit } from "./editing/view";
import { useUIContext } from "common/uicontext/store";
import { useLocation } from "wouter";
import { UrlPathOfPublicSection } from "common/paths";
var View = function () {
    var _a = useLocation(), setLocation = _a[1];
    var uicontext_state = useUIContext()[0];
    var LU = !!uicontext_state.data.logged_user;
    React.useEffect(function () {
        if (uicontext_state.initialized && !LU) {
            setLocation("".concat(UrlPathOfPublicSection, "/kalendar_akci"));
        }
    }, [uicontext_state.initialized, LU]);
    return React.createElement(React.Fragment, null, uicontext_state.initialized && LU &&
        React.createElement(Switch, null,
            React.createElement(Route, { path: "".concat(UrlPathOfPublicSection, "/planovani_akci/editace/:eventId") }, function (params) { return params ? React.createElement(PlanningEdit, { eventId: parseInt(params.eventId) }) : null; }),
            React.createElement(Route, null, React.createElement(EventPlanningList, null))));
};
export { View as EventPlaning, };
